import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export default function EmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailRegex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,5}$');
    if (control.value) {
      const validEmail = emailRegex.test(control.value);
      return validEmail ? null : { invalidEmail: true };
    } else return null;
  };
}
